import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { login as loginAction, logout as logoutAction } from '../store/slices/authSlice';
import { AuthRequest } from '../services/api/authApi';
import { RootState } from '../store';

export const useAuth = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { isAuthenticated, user, token } = useSelector((state: RootState) => state.auth);

  const login = async (credentials: AuthRequest) => {
    try {
      // In a real app, this would call the API
      // const response = await authApi.login(credentials);
      
      // Mock successful login for now
      const mockResponse = {
        token: 'fake-jwt-token',
        user: {
          id: '1',
          email: credentials.email,
          name: 'Test User',
        },
      };
      
      dispatch(loginAction(mockResponse));
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error instanceof Error ? error.message : 'Login failed' 
      };
    }
  };

  const register = async (data: { name: string; email: string; password: string }) => {
    try {
      // In a real app, this would call the API
      // const response = await authApi.register(data);
      
      // Mock successful registration
      const mockResponse = {
        token: 'fake-jwt-token',
        user: {
          id: '1',
          email: data.email,
          name: data.name,
        },
      };
      
      dispatch(loginAction(mockResponse));
      return { success: true };
    } catch (error) {
      return { 
        success: false, 
        error: error instanceof Error ? error.message : 'Registration failed' 
      };
    }
  };

  const logout = () => {
    // In a real app, you would call the API
    // authApi.logout();
    
    dispatch(logoutAction());
    navigate('/');
  };

  return {
    isAuthenticated,
    user,
    token,
    login,
    register,
    logout,
  };
};
